import { createFileRoute } from "@tanstack/react-router";
import { PublicAngebot } from "@/pages/PublicAngebot";

/**
 * Bewusst **außerhalb** von `_angemeldet` — wie `/drehplan/$token` und
 * `/review/$token`: Die Angebotsseite (Angebotstool, 12.09.2026) geht an
 * Interessenten OHNE Konto. Der lange, serverseitig vergebene Token aus der
 * Angebots-Mail ist der Zugang; die Datengrenze hält das Backend.
 */
export const Route = createFileRoute("/angebot/$token")({
	component: AngebotSeite,
});

function AngebotSeite() {
	const { token } = Route.useParams();
	return <PublicAngebot token={token} />;
}
